import privacyPolicy from '@/shared/files/privacy-policy.pdf';
import userAgreementDev from '@/shared/files/dev/user-agreement.pdf';
import userAgreementTest from '@/shared/files/test/user-agreement.pdf';
import userAgreementProd from '@/shared/files/prod/user-agreement.pdf';

import { getAppEnvironment } from './runtimeEnvironment';
export type { AppEnvironment as AppRuntimeEnv } from './runtimeEnvironment';

export const detectEnv = getAppEnvironment;

export const PRIVACY_POLICY_PDF = privacyPolicy;

export function getUserAgreementPdf(): string {
  const env = detectEnv();
  switch (env) {
    case 'prod':
      return userAgreementProd;
    case 'test':
      return userAgreementTest;
    case 'dev':
      return userAgreementDev;
    default:
      return userAgreementProd;
  }
}
